/**
 * O que, entre os eventos `arquivo` do turno, o CONSULTOR pode ver.
 *
 * ★ [21/09/2026] O owner mandou o print de um `/quem-migrar` que falhou e mostrava,
 * sob "Arquivos gerados":
 *
 *     _workspace/snapshot.tar.gz        manifesto · arquivo · 45 B
 *
 * Isso é o SNAPSHOT INTERNO do workspace do worker — `snapshot.publicar` o grava a cada
 * turno para restaurar o diretório de trabalho no turno seguinte, e 45 B é um `tar.gz`
 * vazio. Não é entrega: é estado interno vazando para a tela, e num turno que sequer
 * produziu resposta ("O agente não conseguiu concluir este turno").
 *
 * ★★ A régua já existia — no BACKEND. `core/artefatos_autorizacao.py:88` declara
 * `TIPOS_ENTREGAVEIS = frozenset({'anexo', 'artefato'})` e a listagem de Entregas
 * (`GET /conversas/{id}/artefatos`) filtra por ela. O cartão de STREAMING não filtrava
 * nada, então o mesmo snapshot que a lista de download escondia aparecia no cartão.
 *
 * ⚠️ Lista BRANCA, nunca lista negra. Excluir `'manifesto'` deixaria passar o próximo
 * tipo interno que o contrato ganhar; aceitar só o que é entregável mantém a decisão
 * explícita e faz o tipo novo aparecer como ausência (que alguém nota) em vez de como
 * vazamento (que ninguém nota).
 *
 * Sem `?.`/`??` — o Babel deste projeto não transpila.
 */

/**
 * Os valores de `d_arquivo.tipo` (`spec-002/contracts/events.schema.json`) que a tela
 * mostra. Espelha `TIPOS_ENTREGAVEIS` do backend, e pelo MESMO motivo: `manifesto` é
 * estado do worker, não entrega do usuário.
 */
export const TIPOS_VISIVEIS_AO_USUARIO = Object.freeze(['anexo', 'artefato'])

/**
 * Este evento `arquivo` é para o usuário ver?
 *
 * ★ Evento SEM `tipo` continua visível: o campo é opcional no contrato e um produtor
 * antigo que não o preencha não pode perder a entrega dele. O que se recusa é o tipo
 * interno DECLARADO — o silêncio não é motivo para esconder.
 *
 * @param {Object} evento O evento `arquivo` (ou o `data` dele já desembrulhado).
 * @returns {Boolean}
 */
export function ehEntregaVisivel(evento) {
  const alvo = (evento && evento.data) || evento || {}
  const tipo = alvo.tipo
  if (!tipo) return true
  return TIPOS_VISIVEIS_AO_USUARIO.indexOf(String(tipo)) !== -1
}

/**
 * Só os eventos `arquivo` que o consultor pode ver.
 *
 * @param {Array<Object>} eventos
 * @returns {Array<Object>}
 */
export function entregasVisiveis(eventos) {
  return (eventos || []).filter(ehEntregaVisivel)
}
